import { createReducer, on } from '@ngrx/store';
import { ScatterPlotPlotType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { setStartDate } from './start-date.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
export const startDate = createReducer(null, on(setScatterPlot, (state, action) => {
    if (action.scatterPlot.plotType === ScatterPlotPlotType.timeseries) {
        return action.scatterPlot.startDate;
    }
    return state;
}), on(setStartDate, (state, { date }) => {
    return date;
}));
